'use strict';
var Fp = require('fp/app');

module.exports = class avis extends Fp {
	constructor() {
		super()
		this.more = document.querySelector('[data-more]');
	}

	initialize() {
		this.more.addEventListener('click', this.getMoreAvis);
	}
	/**
	 * Méthode pour récupérer des avis supplémentaires
	 */
	getMoreAvis() {
		let url = this.dataset.more,
			index = parseInt(this.dataset.avisIndex);

		super.getPromiseHtml(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				},
				body: new URLSearchParams({
					index: index,
					codeProduit: config.codeProduct
				})
			})
			.then((data) => {
				// on importe le module gérant le templating
				self.config.moduleTemplate.then(() => {
						let cloneWar = require('modules/templateClone');
						let templatingAvis = new cloneWar(document.querySelector('[data-template-clone="avis"]'), data);
						templatingAvis.initialize();
					})
					// On met à jour l'index
					.then(() => {
						let ul = document.getElementById('ListeAvisClient');
						ul.dataset.avisCountLoaded = ul.children.length;
						if (ul.dataset.avisCountLoaded === ul.dataset.avisCount) {
							this.remove()
						} else {
							this.dataset.avisIndex = index + 1;
						}
					})
					.catch((error) => {
						console.error(error);
					});
			})
			.catch((error) => {
				console.error(error);
			});
	}
}